import { render } from "./GroupDetails.vue?vue&type=template&id=0182bb70&scoped=true"
import script from "./GroupDetails.vue?vue&type=script&lang=js"
export * from "./GroupDetails.vue?vue&type=script&lang=js"

import "./GroupDetails.vue?vue&type=style&index=0&id=0182bb70&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0182bb70"]])

export default __exports__